export default __webpack_public_path__ + "static/media/warning.09e6e06d.svg";